{
    "PartitionModal_AddTitle": "Partitie toevoegen",
    "PartitionModal_ChangeTitle": "Partitie wijzigen",
    "PartitionModal_ViewTitle": "Weergavepartitie",
    "PartitionModal_PromptMessage": "U hebt niet-opgeslagen partitiewijzigingen. Wilt u afsluiten zonder op te slaan?",
    "PartitionModal_PromptConfirm": "Uitgang",
    "PartitionModal_PromptCancel": "Annuleren",
    "PartitionModal_Tab_Details": "Details",
    "PartitionModal_Tab_SiteSettings": "Site-instellingen",
    "PartitionModal_Tab_Synchronisation": "Synchronisatie",
    "PartitionModal_Tab_Advanced": "Geavanceerd",
    "PartitionModal_Tab_CommunicationStatus": "Synchronisatiestatus",
    "PartitionModal_Loading": "Laden...",
    "PartitionModal_Button_Close": "Dichtbij",
    "PartitionModal_Button_Cancel": "Annuleren",
    "PartitionModal_Button_Save": "Redden",
    "PartitionModal_RequestFailed": "Verzoek mislukt",
    "PartitionModal_General_Description": "Beschrijving",
    "PartitionModal_General_DescriptionRequired": "Een beschrijving is vereist.",
    "PartitionModal_General_IDInTelSys": "Nee. in telefonieserver (automatisch)",
    "PartitionModal_General_IDInTelSysRequired": "Nee, in de telefonieserver is vereist.",
    "PartitionModal_General_Tags": "Tag",
    "PartitionModal_Details_Identifier": "Identificatiecode",
    "PartitionModal_Details_IdentifierPlaceholder": "[Automatisch toegewezen]",
    "PartitionModal_Details_BillingIdOrTag": "Factuur-ID \/ Label",
    "PartitionModal_Details_BilledMonthly": "Maandelijks gefactureerd",
    "PartitionModal_Details_LicensedFor": "Gelicentieerd voor",
    "PartitionModal_Details_DeleteAcdAgentsOnDowngrade": "ACD-agentvermeldingen automatisch verwijderen",
    "PartitionModal_LicensedFor_None": "Geen",
    "PartitionModal_LicensedFor_AkixiLite": "Akixi Lite",
    "PartitionModal_LicensedFor_AkixiBLF": "Akixi BLF",
    "PartitionModal_LicensedFor_AkixiONE": "Akixi ONE",
    "PartitionModal_LicensedFor_Akixi1000": "Akixi 1000",
    "PartitionModal_LicensedFor_Enterprise": "Onderneming",
    "PartitionModal_LicensedFor_Akixi2000": "Akixi 2000",
    "PartitionModal_LicensedFor_Essentials": "Essentiële zaken",
    "PartitionModal_LicensedFor_Professional": "Professioneel",
    "PartitionModal_LicensedFor_CallCentreAgent": "Callcentermedewerker",
    "PartitionModal_LicensedFor_CallCentreSupervisor": "Callcenter supervisor",
    "PartitionModal_Details_CommonDevices": "Bevat gangbare apparaten",
    "PartitionModal_Details_CommonDevicesPanasonic": "Bevat gangbare apparaten (alleen gangbare DP-apparaten)",
    "PartitionModal_Details_CommunicationEnabled": "Communicatie mogelijk gemaakt",
    "PartitionModal_Site_Timezone": "Tijdzone",
    "PartitionModal_Site_StartOfDay": "Begin van de dag (lokale tijd)",
    "PartitionModal_Site_RecordingPlayback": "Opname afspelen",
    "PartitionModal_Site_RecordingPlayback_None": "Geen",
    "PartitionModal_Site_E164Enabled": "E.164 ingeschakeld",
    "PartitionModal_Site_InternalDigitLength": "Interne cijferlengte",
    "PartitionModal_Site_CountryCodeLocation": "Landcode Locatie",
    "PartitionModal_Sync_NoSettings": "Er zijn geen synchronisatie-instellingen van toepassing op dit type telefonieserver.",
    "PartitionModal_Sync_CommonDevicesNoSettings": "Er zijn geen synchronisatie-instellingen van toepassing op een partitie met gemeenschappelijke apparaten.",
    "PartitionModal_Sync_NameOnTelephonyServer": "Naam op de telefonieserver",
    "PartitionModal_Sync_IDOnTelephonyServerOid": "ID op telefonieserver (OID)",
    "PartitionModal_Sync_SynchronisationTypeSoftOnly": "Synchronisatietype (alleen software)",
    "PartitionModal_Sync_EnterpriseOrProviderID": "Bedrijfs- of provider-ID",
    "PartitionModal_Sync_SynchronisationType": "Synchronisatietype",
    "PartitionModal_Sync_WebexEnvironmentType": "Webex-omgevingstype",
    "PartitionModal_Sync_TeamsEnvironmentType": "Teams Omgevingstype",
    "PartitionModal_Sync_EnterpriseID": "Bedrijfs-ID",
    "PartitionModal_Sync_GroupID": "Groeps-ID",
    "PartitionModal_Sync_UserInLocation": "Gebruiker op locatie",
    "PartitionModal_Sync_IDOnTelephonyServer": "ID op de telefonieserver",
    "PartitionModal_Sync_TypeOnTelSys": "Typ op Telsys",
    "PartitionModal_Sync_WebexTypeEnvironment": "Webex-achtige omgeving",
    "PartitionModal_Sync_ComponentType_Unknown": "[Onbekend of niet-gespecificeerd type]",
    "PartitionModal_Sync_ComponentType_BroadWorks_Enterprise": "Onderneming",
    "PartitionModal_Sync_ComponentType_BroadWorks_EnterpriseGroup": "Ondernemingsgroep",
    "PartitionModal_Sync_ComponentType_BroadWorks_ServiceProvider": "Dienstverlener",
    "PartitionModal_Sync_ComponentType_BroadWorks_ServiceProviderGroup": "Dienstverlenersgroep",
    "PartitionModal_Sync_ComponentType_Webex_Organisation": "Organisatie",
    "PartitionModal_Sync_ComponentType_Webex_Location": "Locatie",
    "PartitionModal_Sync_Environment_None": "Geen",
    "PartitionModal_Sync_Environment_Tenant": "Huurder",
    "PartitionModal_Sync_Environment_AuthoriserSelect": "Autorisatie selecteren",
    "PartitionModal_Sync_Environment_SecurityGroups": "Beveiligingsgroepen",
    "PartitionModal_Sync_SynchronisationType_Soft": "Zacht",
    "PartitionModal_Sync_SynchronisationType_OneTimeFull": "Eenmalig volledig",
    "PartitionModal_Sync_SynchronisationType_Full": "Vol",
    "PartitionModal_Sync_SynchronisationType_ServicePack": "Servicepakket",
    "PartitionModal_Sync_SecurityGroups": "Beveiligingsgroepen",
    "PartitionModal_Sync_SyncOptions": "Synchronisatieopties",
    "PartitionModal_Sync_SyncOptions_None": "Geen",
    "PartitionModal_Sync_SyncOptions_Endpoints": "Eindpunten",
    "PartitionModal_Sync_SyncOptions_Trunking": "Kabeldoorvoer",
    "PartitionModal_Sync_SyncOptions_Agents": "Agenten + bijbehorende extensies",
    "PartitionModal_Sync_SyncOptions_Supervisors": "Toezichthouders",
    "PartitionModal_Sync_MaintainParity": "Behoud de gelijkheid",
    "PartitionModal_Sync_ForceMonitored": "Gedwongen bewaking",
    "PartitionModal_Sync_SupervisorPermissions": "Schakel standaard de beheerdersrechten voor de telefonieserver in.",
    "PartitionModal_Sync_SyncNow": "Nu synchroniseren",
    "PartitionModal_Sync_PhotoSyncNow": "Foto's nu synchroniseren",
    "PartitionModal_Advanced_CtiLoggingEnabled": "CTI-registratie",
    "PartitionModal_Advanced_Trunking": "Kabeldoorvoer",
    "PartitionModal_Advanced_TrunkingBurst": "Trunking (Burst)",
    "PartitionModal_Advanced_TrunkingCapacity": "Kabelcapaciteit",
    "PartitionModal_Advanced_TrunkingCapacityBurst": "Trunkingcapaciteit (piekbelasting)",
    "PartitionModal_Advanced_TrunkCapacity": "Bagageruimte",
    "PartitionModal_Advanced_TrunkCapacityBurst": "Trunkcapaciteit (piekbelasting)",
    "PartitionModal_CommStatus_SyncStatusTitle": "Synchronisatiestatus",
    "PartitionModal_CommStatus_SyncLastStarted": "Laatst gestart op:",
    "PartitionModal_CommStatus_SyncLastStarted_Placeholder": "—",
    "PartitionModal_CommStatus_SyncLastError": "Synchronisatiestatus \/ fout",
    "PartitionModal_CommStatus_SyncLastError_Placeholder": "Er is nog geen synchronisatiestatus beschikbaar.",
    "NAME": "PartitionModaal"
}